/** @import {ClientOrAdminFirebase} from '../types/ClientOrAdminFirebase.js' */

/**
 * Gets a custom storage service that works for both client and admin Firebase SDKs. Note:
 * - Not all methods are supported by this wrapper, though some could be added if needed.
 * - Some methods may return different results depending on the SDK used.
 * - Some methods may throw different errors depending on the SDK used.
 * @param {ClientOrAdminFirebase} firebase
 */
export function getClientOrAdminStorage(firebase) {
  if (firebase == null || !('storage' in firebase)) throw new Error('Firebase SDK does not have storage service');

  const storageService = firebase.storage();
  if ('ref' in storageService) return storageService;

  const defaultBucket = storageService.bucket();
  return {
    ref: (path) => {
      return {
        put: async (file) => {
          return await defaultBucket.file(path).save(file);
        },
        getDownloadURL: async () => {
          if (!('require' in globalThis)) throw new Error('getDownloadURL is not supported in this environment');
          const { getDownloadURL } = require('firebase-admin/storage');
          return await getDownloadURL(defaultBucket.file(path));
        },
        delete: async () => {
          return await defaultBucket.file(path).delete();
        }
      };
    }
  };
}
